import { fetchDwtDefraSubmissionsReport } from '../../../dwt-defra-submissions/report/fetch-dwt-defra-submissions-report';
import { readDwtDefraSubmissionsTaskPaneFilterFromDom } from '../../../dwt-defra-submissions/utils/read-dwt-defra-submissions-task-pane-filter.util';
import { formatDwtDefraSubmissionsRecordsToTabularSheet } from '../../formatters/dwt-defra-submissions-tabular.formatter';
import type { ReportFetchContext, ReportFetchResult } from '../report-fetch.types';
import { completeFetchedReportWithTabularWrite } from '../utils/complete-fetched-report-with-tabular-write.util';

/** DWT - Submissions to DEFRA: DOM → Get-RegulatoryReports → field rows → sheet writer. */
export async function executeDwtDefraSubmissionsReportingTargetFetch(
    ctx: ReportFetchContext
): Promise<ReportFetchResult> {
    const filter = readDwtDefraSubmissionsTaskPaneFilterFromDom();
    const fetchResult = await fetchDwtDefraSubmissionsReport(ctx.accessToken, filter, {
        fetchGetDwtDefraSubmissions: (token, payload) =>
            ctx.deps.dwtDefraSubmissionsApi.fetchGetDwtDefraSubmissions(token, payload),
    });
    return completeFetchedReportWithTabularWrite(
        fetchResult,
        formatDwtDefraSubmissionsRecordsToTabularSheet,
        (payload, mode) => ctx.deps.tabularSheetWriter.writeTabularSheetToWorksheet(payload, mode),
        ctx.tabularWriteMode
    );
}
